import { Routes } from '@angular/router';
import { authGuard, shoppingGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/client/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'build-kit/:id', // Rota pública para montar o kit
    canActivate: [shoppingGuard],
    loadComponent: () => import('./features/client/kit-builder/kit-builder.component').then(m => m.KitBuilderComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'checkout', // Rota pública: o login só é exigido para confirmar o pedido
    canActivate: [shoppingGuard],
    loadComponent: () => import('./features/client/checkout/checkout.component').then(m => m.CheckoutComponent)
  },
  {
    path: 'my-orders',
    canActivate: [authGuard], // Só o cliente tem pedidos próprios
    data: { role: 'CUSTOMER' },
    loadComponent: () => import('./features/client/my-orders/my-orders.component').then(m => m.MyOrdersComponent)
  },
  {
    path: 'profile', // Dados da conta: cliente e admin
    canActivate: [authGuard],
    loadComponent: () => import('./features/client/profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'admin',
    canActivate: [authGuard], // Apenas o painel admin exige a role ADMIN
    data: { role: 'ADMIN' },
    loadComponent: () => import('./features/admin/dashboard/dashboard.component').then(m => m.DashboardComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'orders' },
      {
        path: 'orders',
        loadComponent: () => import('./features/admin/orders-manager/orders-manager.component').then(m => m.OrdersManagerComponent)
      },
      {
        path: 'production', // Tela da cozinha: pedidos Em Produção
        loadComponent: () => import('./features/admin/production-board/production-board.component').then(m => m.ProductionBoardComponent)
      },
      {
        path: 'reports', // Relatórios de pedidos: faturamento, kits e sabores mais vendidos
        loadComponent: () => import('./features/admin/reports/reports.component').then(m => m.ReportsComponent)
      },
      {
        path: 'customers',
        loadComponent: () => import('./features/admin/customers-manager/customers-manager.component').then(m => m.CustomersManagerComponent)
      },
      {
        path: 'delivery', // Fretes: valores de entrega e os bairros de cada um
        loadComponent: () => import('./features/admin/delivery-manager/delivery-manager.component').then(m => m.DeliveryManagerComponent)
      },
      {
        path: 'kits',
        loadComponent: () => import('./features/admin/kit-manager/kit-manager.component').then(m => m.KitManagerComponent)
      },
      {
        path: 'whatsapp', // Conexão do WhatsApp que envia os avisos da loja (Evolution API)
        loadComponent: () => import('./features/admin/whatsapp-manager/whatsapp-manager.component').then(m => m.WhatsappManagerComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
